// src/components/BlogPostCard.tsx
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Calendar, Clock } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

interface BlogPost {
  id: number;
  title: string;
  excerpt: string;
  image: string;
  date: string;
  readTime: string;
  category: string;
}

interface BlogPostCardProps {
  post: BlogPost;
}

const BlogPostCard = ({ post }: BlogPostCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      <Link to={`/nasveti-blog/${post.id}`} className="block h-full">
        <Card className="h-full overflow-hidden border-stone-200 hover:shadow-[0_0_15px_rgba(240,90,40,0.3)] hover:border-secondary transition-all duration-300">
          <CardContent className="p-6">
            <div className="mb-3">
              <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary/10 text-secondary rounded-full">
                {post.category}
              </span>
            </div>
            
            <h3 className="text-xl font-semibold text-stone-800 mb-3 line-clamp-2">
              {post.title}
            </h3>
            
            <div className="flex text-sm text-stone-500 mb-4">
              <span className="flex items-center mr-4">
                <Calendar size={14} className="mr-1" /> {post.date}
              </span>
              <span className="flex items-center">
                <Clock size={14} className="mr-1" /> {post.readTime} branja
              </span>
            </div>
            
            <p className="text-stone-600 line-clamp-3 mb-4">
              {post.excerpt}
            </p>
          </CardContent>
        </Card>
      </Link>
    </motion.div>
  );
};

export default BlogPostCard;
